<template>
  <section class="detail-box">
    <!-- <section class="banner-box"></section> -->
    <section class="content-box content1200">
      <section class="content-head">
        <router-link v-if="navInfo && navInfo.primaryKey"
                      :to="{
                        name: navInfo.navigationType,
                        query: {
                          primaryKey: navInfo.primaryKey
                        }
                      }">
        {{navInfo.navigationName}}</router-link>
        <template v-if="navContentInfo && navContentInfo.primaryKey"> > <span>{{navContentInfo.contentTitle}}</span>
        </template>
      </section>
      <section class="content-body">
        <div class="content-main" v-if="richInfo && richInfo.richText" v-html="richInfo.richText"></div>
        <div class="null-box" v-else>暂无内容！！！</div>
      </section>
    </section>
  </section>
</template>
<script>
import { richDetail, navDetail, navContentDetail } from '../../api/index'
export default {
  data () {
    return {
      richInfo: {
        richText: ''
      },
      navInfo: {},
      navContentInfo: {}
    }
  },
  methods: {
    async getRichDetail () {
      var res = await richDetail({targetKey: this.$route.query.primaryKey})
      if (res.data) {
        this.richInfo = res.data
      }
    },
    async getNavDetail () {
      var res = await navDetail({primaryKey: this.$route.query.parentPrimaryKey})
      this.navInfo = res.data
    },
    async getNavContentDetail () {
      var res = await navContentDetail({primaryKey: this.$route.query.primaryKey})
      this.navContentInfo = res.data
    }
  },
  mounted () {
    if (this.$route.query.parentPrimaryKey) {
      this.getNavDetail()
    }
    if (this.$route.query.childPrimaryKey) {
      this.getNavContentDetail()
    }
    
    this.getRichDetail()
  }
}
</script>
<style lang="scss">
.detail-box {

  .banner-box {
    background: #B1CECC;
    height: 560px;
  }

  .content-box {
    margin: 0 auto 100px;
    box-shadow: 4px 6px 10px rgba(0,0,0,0.3);
    position: relative;

    .content-head {
      background: #B1CECC;
      height: 100px;
      padding: 0 75px;
      line-height: 100px;
      font-size: 25px;
      color: #fff;

      a {
        color: #fff;
      }

      span {
        color: #f1d9b0;
      }
    }

    .content-body {
      padding: 40px 75px 40px;
      background: #fff;
      min-height: 500px;

      .content-main {
        line-height: 1.5em;
        img {
          display: block;
          max-width: 100%;
        }
        * {
          line-height: 1.5em;
        }
      }
    }
  }
}
  @media screen and (max-width: 768px) {
   
    .detail-box .content-box .content-body {
      padding: 20px 30px;
    }
  }
</style>